import { useQuery } from "@tanstack/react-query";
import {
	ProgramActivitySummaryFilters,
	ProgramActivitySummaryResponse,
	reportsService,
} from "../../services/reports.service";

// SIMS-5596 — Program Activity Summary. Refetches automatically on any filter
// change (all in the queryKey); disabled until a program is selected.
const useProgramActivitySummary = (filters: ProgramActivitySummaryFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<ProgramActivitySummaryResponse>({
		queryKey: [
			"reports-program-activity-summary",
			filters.accountId,
			filters.programId,
			filters.orgUnitIds ?? "",
			filters.payerIds ?? "",
			filters.groupLabelIds ?? "",
			filters.providerId ?? "",
			filters.startDate ?? "",
			filters.endDate ?? "",
		],
		queryFn: () => reportsService.getProgramActivitySummary(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useProgramActivitySummary;
